<template>
	<div class="s-white-bg p-user-select" style="overflow:scroll; ">
		<loadingContent v-if="true"></loadingContent>
		<div  class="p-margin20 p-margin-top40  p-padding-top20 p-padding-bottom10 p-box-center-y p-space-between p-font1 p-black p-border2 p-color6-border" @click="selectMaxHr" >
			<span>
			设置最大心率
			</span>
			<div  style="padding-top: 0.4rem;padding-right:1rem" class="p-margin-left30 p-font0-8 p-box-center-x">
				<span>{{maxHr}}次/分</span>
				<img :src="require('@/assets/img/box_detail_down.png')" style="width:1rem; height:0.5rem;margin:0.3rem 1rem 0.3rem  0.5rem " />
			</div> 
		</div>

		<div  class="p-margin20 p-margin-top30 p-box-center-y p-font1 p-black">
			区间范围
		</div>
		<div  class="p-center p-margin-left40 p-font0-8 p-margin-top20"  style="text-align:left;">
			<span  class="p-inline-block"  style="width:0.8rem; height:0.8rem;border-radius:100%;"  :style="`background:${  sportHrWarmupColor  };`"></span>
			<span  style="width:30%;padding-left:0.5rem;text-align:left;"   >热身&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
			<span  style="padding-left:2rem;width:30%;text-align:center;"   >50%-60%</span>   
			<span  style="float:right;padding-right:2rem;text-align:right">{{(maxHr*50)/100}}-{{(maxHr*60)/100}}次/分</span><br/><br/>

			<span  class="p-inline-block"  style="width:0.8rem; height:0.8rem; border-radius:100%;"  :style="`background:${  sportHrFatburningColor  };`"></span>
			<span  style="width:30%;padding-left:0.5rem;text-align:left;"   >燃脂&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>   
			<span  style="padding-left:2rem;width:30%;text-align:center;"   >60%-70%</span>   
			<span  style="float:right;padding-right:2rem;text-align:right">{{(maxHr*60)/100}}-{{(maxHr*70)/100}}次/分</span><br/><br/>

			<span  class="p-inline-block"  style="width:0.8rem; height:0.8rem; border-radius:100%;" :style="`background:${  sportHrAerobicColor  };`"></span>
			<span  style="width:30%;padding-left:0.5rem;text-align:left;"   >有氧耐力&nbsp;</span>   
			<span  style="padding-left:2rem;width:30%;text-align:center;"   >70%-80%</span>   
			<span  style="float:right;padding-right:2rem;text-align:right">{{(maxHr*70)/100}}-{{(maxHr*80)/100}}次/分</span><br/><br/>

			<span  class="p-inline-block"  style="width:0.8rem; height:0.8rem; border-radius:100%;" :style="`background:${  sportHrAnaerobicColor  };`"></span>
			<span  style="width:30%;padding-left:0.5rem;text-align:left;"   >无氧耐力&nbsp;</span>   
			<span  style="padding-left:2rem;width:30%;text-align:center;"   >80%-90%</span>   
			<span  style="float:right;padding-right:2rem;text-align:right">{{(maxHr*80)/100}}-{{(maxHr*90)/100}}次/分</span><br/><br/>

			<span  class="p-inline-block"  style="width:0.8rem; height:0.8rem; border-radius:100%;" :style="`background:${  sportHrLimitColor  };`"></span>
			<span  style="width:30%;padding-left:0.5rem;text-align:left;"   >极限&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>   
			<span  style="padding-left:2rem;width:30%;text-align:center;"   >90%-100%</span>   
			<span  style="float:right;padding-right:2rem;text-align:right">{{(maxHr*90)/100}}-{{maxHr}}次/分</span><br/><br/>
		</div>
		<div  style="height:2rem;"></div>
	</div>
</template>

<script>
	
	import mixins from '@/utils/mixins.js'
	export default {
		name: "sportReportMaxHrSetting",
		mixins: [mixins],
	data() {
		return {
			pid: 0,
			// listData:[{index:0,text:100},{index:1,text:110},{index:2,text:120},{index:3,text:130},{index:4,text:140},{index:5,text:150},{index:6,text:160},{index:7,text:170},{index:8,text:180},{index:9,text:190},{index:10,text:200}],
			listData:[100,110,120,130,140,150,160,170,180,190,200],
			maxHr:200,
		}
	},
		methods: {
			getData(){
				// this.getNibpReportDetail();
				this.maxHr=this.$route.query.sportData.intervalhr;
			},
			selectMaxHr(){
				console.log('开始showList')
				//列表弹窗
				// 暂时屏蔽设置最大心率区间
				// let options={
				// 	title:"设置最大心率",
				// 	message:"设置最大心率",
				// 	options:{
				// 			yesCallbackFunction:this.confirmMaxHr,
				// 			rightColor:this.colorArr[4],
				// 		//  noCallbackFunction:this.noCallbackFunction,
				// 			yesText:'确认',
				// 			noText:'取消',
				// 			listData:this.listData,
				// 		}
				// }
				// this.$installdialog.list(options);
			},
			confirmMaxHr(tmpMaxHrIndex){
				console.log('  tmpMaxHrIndex=   ',tmpMaxHrIndex)
				if(-1!=tmpMaxHrIndex){
					this.maxHr=this.listData[tmpMaxHrIndex];
				}
			}

		},
		created() {
			document.title = this.$t('sport.sportHrSet');
			this.getData();

			
		},
		mounted(){
		}

	}
</script>

<style scoped>

</style>
